"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledWithProps = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var omit_1 = tslib_1.__importDefault(require("lodash/omit"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

function styledWithProps(Tag, unsafeProps, css) {
  var Component = function Component(props) {
    var safeProps = omit_1.default(props, tslib_1.__spreadArrays(unsafeProps, ['innerRef']));

    if (props.ref) {
      safeProps.ref = props.ref;
    } else if (props.innerRef) {
      safeProps.ref = props.innerRef;
    }

    if (props.children) {
      return react_1.default.createElement(Tag, tslib_1.__assign({}, safeProps), props.children);
    }

    return react_1.default.createElement(Tag, tslib_1.__assign({}, safeProps));
  };

  return styled_components_1.default(Component)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t", ";\n\t"], ["\n\t\t", ";\n\t"])), css);
}

exports.styledWithProps = styledWithProps;
var templateObject_1;